(function () {
  'use strict';

  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var PHONE_PATTERN = /^[0-9]{10}$/;

  var state = {
    sheetUrl: '',
    successMessage: 'Thank you! We will be in touch soon.',
    payload: null
  };

  function stripHtml(value) {
    if (!value) return '';
    var el = document.createElement('div');
    el.innerHTML = String(value);
    return (el.textContent || el.innerText || '').replace(/\s+/g, ' ').trim();
  }

  function plainVariantPrice(variant) {
    if (!variant) return '';
    if (variant.price_plain) return variant.price_plain;
    if (variant.price_formatted) return stripHtml(variant.price_formatted);
    if (typeof variant.price === 'number') {
      return '₹ ' + (variant.price / 100).toLocaleString('en-IN');
    }
    return '';
  }

  function getModal() {
    return document.querySelector('[data-rabitat-signup-modal]');
  }

  function getEls(modal) {
    return {
      modal: modal,
      formView: modal.querySelector('[data-signup-form-view]'),
      successView: modal.querySelector('[data-signup-success-view]'),
      form: modal.querySelector('[data-signup-form]'),
      emailInput: modal.querySelector('[data-signup-email]'),
      phoneInput: modal.querySelector('[data-signup-phone]'),
      emailError: modal.querySelector('[data-signup-email-error]'),
      phoneError: modal.querySelector('[data-signup-phone-error]'),
      formError: modal.querySelector('[data-signup-form-error]'),
      submitBtn: modal.querySelector('[data-signup-submit]'),
      productTitle: modal.querySelector('[data-signup-product-title]'),
      variantName: modal.querySelector('[data-signup-variant-name]'),
      successMessage: modal.querySelector('[data-signup-success-message]')
    };
  }

  function setError(el, message) {
    if (!el) return;
    if (message) {
      el.textContent = message;
      el.hidden = false;
    } else {
      el.textContent = '';
      el.hidden = true;
    }
  }

  function validateEmail(value) {
    var email = (value || '').trim();
    if (!email) return 'Email is required.';
    if (!EMAIL_PATTERN.test(email)) return 'Enter a valid email address.';
    return '';
  }

  function sanitizePhone(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 10);
  }

  function validatePhone(value) {
    var phone = sanitizePhone(value);
    if (!phone) return 'Phone number is required.';
    if (!PHONE_PATTERN.test(phone)) return 'Enter a valid 10-digit phone number.';
    return '';
  }

  function resetForm(els) {
    if (!els.form) return;
    els.form.reset();
    setError(els.emailError, '');
    setError(els.phoneError, '');
    setError(els.formError, '');
    if (els.emailInput) els.emailInput.classList.remove('is-invalid');
    if (els.phoneInput) els.phoneInput.classList.remove('is-invalid');
    if (els.formView) {
      els.formView.hidden = false;
      els.formView.removeAttribute('hidden');
      els.formView.classList.remove('is-hidden');
    }
    if (els.successView) {
      els.successView.hidden = true;
      els.successView.setAttribute('hidden', '');
      els.successView.classList.remove('is-visible');
    }
    if (els.submitBtn) {
      els.submitBtn.disabled = false;
      els.submitBtn.removeAttribute('aria-busy');
    }
  }

  function closeModal() {
    var modal = getModal();
    if (!modal) return;

    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    var els = getEls(modal);
    resetForm(els);
    state.payload = null;
  }

  function openModal(detail) {
    var modal = getModal();
    if (!modal || !detail) return;

    var sectionRoot = detail.sectionRoot;
    if (sectionRoot) {
      state.sheetUrl = sectionRoot.getAttribute('data-google-sheet-url') || '';
      state.successMessage = sectionRoot.getAttribute('data-signup-success-message') || state.successMessage;
    }

    var variant = detail.variant || {};
    state.payload = {
      product_id: detail.productId || '',
      product_title: detail.productTitle || '',
      product_handle: detail.productHandle || '',
      variant_id: variant.id || '',
      variant_name: variant.name || '',
      variant_price: plainVariantPrice(variant)
    };

    var els = getEls(modal);
    resetForm(els);

    if (els.productTitle) els.productTitle.textContent = state.payload.product_title;
    if (els.variantName) els.variantName.textContent = state.payload.variant_name;
    if (els.successMessage) els.successMessage.textContent = state.successMessage;

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    if (els.emailInput) els.emailInput.focus();
  }

  function showSuccess() {
    var modal = getModal();
    if (!modal) return;

    var els = getEls(modal);

    if (els.successMessage) {
      els.successMessage.textContent = state.successMessage;
    }

    if (els.formView) {
      els.formView.hidden = true;
      els.formView.setAttribute('hidden', '');
      els.formView.classList.add('is-hidden');
    }

    if (els.successView) {
      els.successView.hidden = false;
      els.successView.removeAttribute('hidden');
      els.successView.classList.add('is-visible');
    }

    window.setTimeout(function () {
      closeModal();
    }, 3000);
  }

  function queueGoogleSheetSubmission(payload) {
    if (!state.sheetUrl) return;

    var body = JSON.stringify(payload);
    var blob = new Blob([body], { type: 'text/plain;charset=utf-8' });

    if (navigator.sendBeacon && navigator.sendBeacon(state.sheetUrl, blob)) {
      return;
    }

    submitToGoogleSheet(payload).catch(function (error) {
      console.warn('Rabitat signup sheet sync failed:', error);
    });
  }

  function submitToGoogleSheet(payload) {
    if (!state.sheetUrl) {
      return Promise.reject(new Error('Google Sheet URL is not configured for this section.'));
    }

    // Apps Script returns an opaque/cross-origin response in the browser.
    // The row is still saved; treat a completed request as success.
    return fetch(state.sheetUrl, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'text/plain;charset=utf-8'
      },
      body: JSON.stringify(payload)
    }).then(function () {
      return { success: true };
    });
  }

  function bindModal() {
    var modal = getModal();
    if (!modal || modal.dataset.signupBound === 'true') return;
    modal.dataset.signupBound = 'true';

    var els = getEls(modal);

    modal.querySelectorAll('[data-signup-close]').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && !modal.hidden) {
        closeModal();
      }
    });

    if (els.phoneInput) {
      els.phoneInput.addEventListener('input', function () {
        els.phoneInput.value = sanitizePhone(els.phoneInput.value);
        setError(els.phoneError, '');
        els.phoneInput.classList.remove('is-invalid');
      });
    }

    if (els.emailInput) {
      els.emailInput.addEventListener('input', function () {
        setError(els.emailError, '');
        els.emailInput.classList.remove('is-invalid');
      });
    }

    if (els.form) {
      els.form.addEventListener('submit', function (event) {
        event.preventDefault();

        var emailError = validateEmail(els.emailInput ? els.emailInput.value : '');
        var phoneError = validatePhone(els.phoneInput ? els.phoneInput.value : '');

        setError(els.emailError, emailError);
        setError(els.phoneError, phoneError);
        setError(els.formError, '');

        if (els.emailInput) els.emailInput.classList.toggle('is-invalid', !!emailError);
        if (els.phoneInput) els.phoneInput.classList.toggle('is-invalid', !!phoneError);

        if (emailError || phoneError) return;

        if (!state.payload) {
          setError(els.formError, 'Product details are missing. Please try again.');
          return;
        }

        if (!state.sheetUrl) {
          setError(els.formError, 'Google Sheet URL is not configured for this section.');
          return;
        }

        if (els.submitBtn) {
          els.submitBtn.disabled = true;
          els.submitBtn.setAttribute('aria-busy', 'true');
        }

        var submission = {
          timestamp: new Date().toISOString(),
          email: els.emailInput.value.trim(),
          phone: sanitizePhone(els.phoneInput.value),
          product_id: state.payload.product_id,
          product_title: state.payload.product_title,
          product_handle: state.payload.product_handle,
          variant_id: state.payload.variant_id,
          variant_name: state.payload.variant_name,
          variant_price: state.payload.variant_price,
          page_url: window.location.href
        };

        showSuccess();
        queueGoogleSheetSubmission(submission);
      });
    }
  }

  function dispatchSignupOpenFromTrigger(trigger) {
    if (!trigger || trigger.getAttribute('aria-disabled') === 'true') return;

    var signupSection = trigger.closest('[data-signup-collection]');
    if (!signupSection) return;

    var card = trigger.closest('[data-product-card]');
    if (!card) return;

    var jsonEl = card.querySelector('[data-product-card-variants]');
    if (!jsonEl) return;

    var variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (error) {
      return;
    }

    if (!variants.length) return;

    var variantId = trigger.getAttribute('data-current-variant-id') || card.getAttribute('data-initial-variant-id');
    var selectedVariant = variants.find(function (variant) {
      return String(variant.id) === String(variantId);
    }) || variants[0];

    openModal({
      productId: card.getAttribute('data-product-id') || '',
      productTitle: card.getAttribute('data-product-title') || '',
      productHandle: card.getAttribute('data-product-handle') || '',
      variant: selectedVariant,
      sectionRoot: signupSection
    });
  }

  document.addEventListener('rabitat:signup:open', function (event) {
    openModal(event.detail || {});
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-signup-collection] [data-product-card-cart]');
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();
    dispatchSignupOpenFromTrigger(trigger);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindModal);
  } else {
    bindModal();
  }

  document.addEventListener('shopify:section:load', bindModal);
})();
